export default __webpack_public_path__ + "assets/morocco-flag.png";